import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import Container from '@/components/organisms/main/staking/history/Container.vue';
import Loading from '@/materials/molecules/Loading.vue';
import ConnectionError from '@/materials/atoms/ConnectionError.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        userInfo: null,
        isAuth: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Suspense, null, {
                default: _withCtx(() => [
                    _createVNode(Container, {
                        "is-auth": props.isAuth,
                        userInfo: props.userInfo,
                        selectedSymbol: ''
                    }, null, 8, ["is-auth", "userInfo"])
                ]),
                fallback: _withCtx(() => [
                    _createVNode(Loading)
                ]),
                error: _withCtx(() => [
                    _createVNode(ConnectionError)
                ]),
                _: 1
            }));
        };
    }
});
